// src/pages/Payments/components/VoucherForm.styles.ts
import styled from "styled-components";

export const ApplyRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const ErrorText = styled.div`
  font-size: 13px;
  color: #c0392b;
  font-weight: 700;
  margin-top: -6px;
  margin-bottom: 8px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const SuccessText = styled.div`
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.green};
  font-weight: 700;
  margin-top: -6px;
  margin-bottom: 8px;
  font-family: ${(p) => p.theme.tokens.font.family};
`;
